import useStore from "../../../store"
import { useTranslation } from "react-i18next"
import formatter from "../../../constants/currencyFormatter"
import InfoItem from "../../common/InfoItem"
import { DateTime } from "luxon"
import { useEffect } from "react"
import { useIsMobile } from "../../../hooks/useIsMobile"
import Breadcrumbs from "../../common/Breadcrumbs"
import useUserType from "../../../hooks/useUserType"
import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"
import TxnType from "../TransferHistory/TxnType"
import formatAccountNumber from "../../../utilities/accountNumber"
import TxnUnitBreakdown from "./TxnUnitBreakdown"
import TxnTitleTrackingLinks from "./TxnTitleTrackingLinks"

export default function TxnPageBody({ txnId = null }) {
  const { t } = useTranslation()
  const txn = useStore((state) => state.txn)
  const isFetchingTxn = useStore((state) => state.isFetchingTxn)
  const fetchTxn = useStore((state) => state.fetchTxn)
  const isMobile = useIsMobile()
  const { isEmployee } = useUserType()

  useEffect(() => {
    fetchTxn(txnId)
  }, [txnId])

  return (
    <>
      {isMobile && isEmployee &&
        <Breadcrumbs />
      }
      <Widget>
        <WidgetHeader title={t('Transaction Information')} showSpinner={isFetchingTxn} />
        <WidgetBody
          isVisible={txn?.id == txnId}
        >
          {txn &&
            <div className="flex flex-col overflow-y-auto pt-2 pl-2 pb-4 bg-grey-900 relative">
              <div className={`flex items-center pt-1`}>
                <TxnType txn={txn} />
                {txn.attributes['type-s']}
              </div>
              <div className='text-4xl text-grey-100 mt-2'>
                {formatter.format(txn.attributes.amount)}
              </div>
              <div className="ml-1">
                <div className="text-lg text-grey-100 mb-2">
                  {DateTime.fromISO(txn.attributes['cdate']).toFormat('M/d/yy')}
                </div>
              </div>
              {txn.attributes.units.map((unit) => (
                <TxnUnitBreakdown key={unit.vin} unit={unit} />
              ))}

              {txn.attributes.transfer &&
                <InfoItem title="ACH Account">
                  <div className="flex flex-col pl-4">
                    <div>{`${txn.attributes.transfer['account_name_for_dealer']}`}</div>
                    <div>{`${txn.attributes.transfer['account_type']} ${formatAccountNumber(txn.attributes.transfer['safe_act'])}`}</div>
                  </div>
                </InfoItem>
              }
              <TxnTitleTrackingLinks units={txn.attributes.units} />
            </div>
          }
        </WidgetBody>
      </Widget>
    </>
  )
}